import * as yup from 'yup';

import { ItemDiscountType } from 'modules/campaigns/types';

import { commonCampaignsValidationSchema } from './commonCampaignsValidationSchema';

export const itemDiscountFormValidationSchema = commonCampaignsValidationSchema.concat(
  yup.object({
    itemIds: yup.array(yup.string()).required().min(1, { id: 'validation.required' }),
    itemTriggerCount: yup.number().required(),
    agreementTermsAndConditions: yup.boolean().required(),
    percentage: yup.number().when('discountType', {
      is: 'percentage_off',
      then: yup.number().required().min(yup.ref('$minPercentage')).max(yup.ref('$maxPercentage')),
    }),
    amount: yup.number().when(['$maxAmount', 'discountType'], {
      is: (maxAmount: number, discountType: ItemDiscountType) =>
        discountType === 'amount_off' && maxAmount !== undefined && maxAmount > 0,
      then: yup.number().required().min(1).max(yup.ref('$maxAmount')),
    }),
  }),
);
export const endOfDayDiscountFormValidationSchema = itemDiscountFormValidationSchema.omit(['totalBudgetSum']).concat(
  yup.object({
    endOfDayItemsCount: yup.number().integer().min(1).required(),
    totalBudgetSum: yup.number().required().moreThan(0),
  }),
);
